import { FC } from 'react';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';

import { Flex, Switch, Text } from '@servicetitan/anvil2';

import * as Styles from './configuration-helpers.module.less';

export const OptInOutField: FC<{ field: FieldState<boolean> }> = observer(({ field }) => (
    <Flex direction="column" gap={2}>
        <Text size="small" className={Styles.optInSwitchLabel}>
            ServiceTitan Email Template Opt In/Out
        </Text>
        <Switch
            label="Opt In"
            onChange={(_, { checked }) => {
                field.onChange(!checked);
            }}
            checked={!field.value}
        />
    </Flex>
));
